import { MapContainer, TileLayer, Marker, Popup, ZoomControl } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const createPinIcon = (color = "#f59e0b") =>
  L.divIcon({
    className: "modern-map-pin",
    html: `
      <div class="modern-map-pin__wrap">
        <span class="modern-map-pin__pulse" style="background:${color}"></span>
        <span class="modern-map-pin__dot" style="background:${color}">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="#0b1f44" aria-hidden="true">
            <path d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5S10.6 6.5 12 6.5s2.5 1.1 2.5 2.5S13.4 11.5 12 11.5z"/>
          </svg>
        </span>
      </div>
    `,
    iconSize: [40, 40],
    iconAnchor: [20, 36],
    popupAnchor: [0, -34],
  });

const ModernMap = ({
  center = [27.7172, 85.324],
  zoom = 13,
  height = "100%",
  markers = [],
  className = "",
  scrollWheelZoom = false,
}) => {
  return (
    <div className={`modern-map ${className}`} style={{ height, width: "100%" }}>
      <MapContainer
        center={center}
        zoom={zoom}
        style={{ height: "100%", width: "100%" }}
        zoomControl={false}
        scrollWheelZoom={scrollWheelZoom}
        attributionControl
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/">CARTO</a>'
          url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
          subdomains="abcd"
          maxZoom={19}
        />
        <ZoomControl position="bottomright" />

        {markers.map((marker) => (
          <Marker
            key={marker.id || `${marker.position[0]}-${marker.position[1]}`}
            position={marker.position}
            icon={createPinIcon(marker.color || "#f59e0b")}
          >
            {marker.popup && (
              <Popup className="modern-map-popup">{marker.popup}</Popup>
            )}
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default ModernMap;
